import { Effect } from "../Materials/effect";
var name = 'highlightsPixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nconst vec3 RGBLuminanceCoefficients=vec3(0.2126,0.7152,0.0722);\nvoid main(void)\n{\nvec4 tex=texture2D(textureSampler,vUV);\nvec3 c=tex.rgb;\nfloat luma=dot(c.rgb,RGBLuminanceCoefficients);\n\n\ngl_FragColor=vec4(pow(c,vec3(25.0-luma*15.0)),tex.a);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var highlightsPixelShader = { name: name, shader: shader };
//# sourceMappingURL=highlights.fragment.js.map